export default __webpack_public_path__ + "35430dafd6081343fae8533c32080bd4.png";